module.exports = __webpack_public_path__ + "media/partenaire/dude_clothes-cbe0865c.png";